import { useState } from "react";

export type ToastVariantType = "success" | "error";

export type SheetToastType = {
  id: string;
  message: string;
  variant: ToastVariantType;
};

export const useSheetToast = () => {
  const [toasts, setToasts] = useState<SheetToastType[]>([]);

  const showToast = (
    message: string,
    variant: ToastVariantType = "success",
  ) => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    setToasts(prev => [...prev, { id, message, variant }]);
  };

  const dismissToast = (id: string) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  };

  const success = (message: string) => showToast(message, "success");
  const error = (message: string) => showToast(message, "error");

  return {
    toasts,
    showToast,
    dismissToast,
    success,
    error,
  };
};
